// 防抖指令
export const debounce = {
  mounted(el, binding) {
    const { value, arg = 300 } = binding
    let timer = null
    el.addEventListener('click', () => {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        value()
      }, Number(arg))
    })
  }
}

// 长按指令
export const longpress = {
  mounted(el, binding) {
    const { value, arg = 2000 } = binding
    let timer = null
    
    el.addEventListener('touchstart', () => {
      timer = setTimeout(() => {
        value()
      }, Number(arg))
    })
    
    el.addEventListener('touchend', () => {
      clearTimeout(timer)
    })
  }
}

// 复制文本指令
export const copy = {
  mounted(el, binding) {
    el.copyData = binding.value
    el.addEventListener('click', () => {
      const textarea = document.createElement('textarea')
      textarea.value = el.copyData
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('Copy')
      document.body.removeChild(textarea)
    })
  }
}

export default {
  debounce,
  longpress,
  copy
} 